import Vue from 'vue'
import Component from 'vue-class-component'
import LeaveConfirm from "@/components/dialogs/leaveConfirmDialog.vue";
Component.registerHooks([
    "beforeRouteEnter",
    "beforeRouteLeave",
    "beforeRouteUpdate",
]);
@Component({
    components: {
        LeaveConfirm,
    },
})
export class saveMixin extends Vue {
    ifShowSaveConfirm: any = false;
    noSaveText: any = '';
    leaveType: any = '';
    routerPath: any = ''
    changeData: any = {}
    get ifCompose() {
        return this.$store.state.ifCompose;
    }
    leaveChange(item: any) { }
    save() {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }
    /**
   * @description 离开页面前保存
   */
    beforeRouteLeave(to: any, from: any, next: any) {
        this.routerPath = to.fullPath;
        // if (this.ifCompose && !this.$store.state.systemInfo.SETTING.ifDesktop) {
        //     this.ifShowSaveConfirm = true;
        //     next(false);
        // } else {
        //     next(true);
        // }
        next(true);
    }
    beforeDestroy(to: any, from: any, next: any) {
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
    }
    handleBeforeUnload(event: any) {
        if (this.ifCompose) {
            // 取消事件的默认行为  
            event.preventDefault();
            //Chrome 需要设置 returnValue 来显示自定义消息  
            event.returnValue = ''
        }
    }
    // 保存确认弹框保存
    changeSave() {
        this.ifShowSaveConfirm = false
        this.save().then(() => {
            if (this.leaveType == "切换") {
                this.leaveChange(this.changeData);
            } else if (this.leaveType == "离开") {
                if (this.routerPath == "/login") {
                    this.$store.commit("updateToken", "");
                    this.$store.commit("updateUser", null);
                    this.$router.replace("/login");
                    setTimeout(() => {
                        location.reload();
                    }, 1000);
                } else {
                    this.$router.push(this.routerPath);
                }
            } else {
                setTimeout(() => {
                    this.$router.back();
                }, 100);
            }
        });
    }
    // 保存确认弹框不保存
    private changeConfirmed() {
        this.ifShowSaveConfirm = false
        this.$store.commit("updateIfCompose", false);
        if (this.leaveType == "切换") {
            this.leaveChange(this.changeData);
        } else {
            if (this.routerPath == "/login") {
                this.$store.commit("updateToken", "");
                this.$store.commit("updateUser", null);
                this.$router.replace("/login");
                setTimeout(() => {
                    location.reload();
                }, 1000);
            } else {
                this.$router.push(this.routerPath);
            }
        }
    }
    mounted() {
        window.addEventListener('beforeunload', this.handleBeforeUnload);
    }
}